import { Box } from '@mui/material'
import { colors } from '@/theme'
import { Group as GroupIcon } from '@mui/icons-material'

export default function DuplicateIcon({ size = 16, iconSize = 14 }: { size?: number; iconSize?: number }) {
  return (
    <Box
      sx={{
        bgcolor: colors.brand.primary,
        borderRadius: '50%',
        width: `${size}px`,
        height: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      <GroupIcon sx={{ color: colors.brand.primaryLight, fontSize: `${iconSize}px` }} />
    </Box>
  )
}
